import { create } from 'zustand'

import type { ToastSlice } from './toast-slice'
import { createToastSlice } from './toast-slice'

const useToastStore = create<ToastSlice>()((...a) => ({
  ...createToastSlice(...a)
}))

export default useToastStore
